import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function Savings() {
  const [tiers, setTiers] = useState([]);
  useEffect(() => {
    api.get("/config/savings").then((r) => setTiers(r.data.tiers || []));
  }, []);

  return (
    <section
      id="savings"
      data-testid="savings-section"
      className="py-24 lg:py-32 bg-[#F5F5F0] text-black"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="mb-14 max-w-3xl">
          <p className="font-mono-label text-[11px] text-neutral-600 mb-4">
            02 · Savings Snapshot
          </p>
          <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter">
            Same components.<br />
            <span className="text-neutral-500">Different math.</span>
          </h2>
          <p className="mt-6 text-neutral-700 text-lg">
            Industry-average distributor pricing for comparable builds vs. what
            we quote. No competitor names — just the delta.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-neutral-800">
          {tiers.map((t) => (
            <div
              key={t.name}
              data-testid={`savings-tier-${t.name.toLowerCase().replace(/\s/g, "-")}`}
              className="bg-[#F5F5F0] p-8 md:p-10 flex flex-col"
            >
              <p className="font-mono-label text-[11px] text-neutral-500">
                {t.name}
              </p>
              <div className="mt-8 space-y-4">
                <div>
                  <p className="text-xs text-neutral-500">Industry</p>
                  <p className="font-display text-2xl line-through text-neutral-500">
                    {t.industry}
                  </p>
                </div>
                <div>
                  <p className="text-xs text-neutral-500">The Sim Guys</p>
                  <p className="font-display font-black text-5xl tracking-tighter">
                    {t.sim_guys}
                  </p>
                </div>
              </div>
              <div className="mt-auto pt-6 border-t border-neutral-800">
                <p className="font-mono-label text-[11px] font-bold">
                  {t.savings}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
